import React from 'react';
import {
  HashRouter,
  Navigate,
  Route,
  Routes
} from 'react-router-dom';
import './App.css';
import AppShell from './components/AppShell';
import ErrorBoundary from './components/ErrorBoundary';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import AnalyticsPage from './pages/admin/AnalyticsPage';
import UsersPage from './pages/admin/UsersPage';
import WordsPage from './pages/admin/WordsPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import LoginPage from './pages/auth/LoginPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';
import ProgressPage from './pages/student/ProgressPage';
import StudyPage from './pages/student/StudyPage';

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      <Route
        element={
          <ProtectedRoute role="student">
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route path="/study" element={<StudyPage />} />
        <Route path="/progress" element={<ProgressPage />} />
      </Route>

      <Route
        element={
          <ProtectedRoute role="admin">
            <AppShell admin />
          </ProtectedRoute>
        }
      >
        <Route path="/admin/users" element={<UsersPage />} />
        <Route path="/admin/words" element={<WordsPage />} />
        <Route path="/admin/analytics" element={<AnalyticsPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <HashRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </HashRouter>
    </ErrorBoundary>
  );
}

export default App;